<template>
    <FilterExpandCollapse label="Language preference" :expand="expanded" v-if="filterContext.type === 'doctor' || filterContext.type === 'dentist'">
      <div class="languages-filter">
        <BaseFCPAutoComplete2
          elementId="languges"
          :options="autoCompleteOptions"
          label="Select a language"
          :hideSearchButton="true"
          v-on:onSelected="onLanguageSelected"
          v-on:onInputChange="onInputChange"
          :initialValue="filterContext.language"
          :style="styles"
          />
        </div>
    </FilterExpandCollapse>
</template>

<script setup>
    const styles = {'max-height':'410px', 'overflow':'scroll'}
    const { filterContext, languages } = useFCPModel()
    const customLanguages = computed(() => {
        const english = { label: 'English', value: '' }
        return [english, ...languages.value]
    })
    const expanded = computed(() => (filterContext.value.languageId || filterContext.value.language == 'English' ? true : false))
    const onLanguageSelected = (event) => {
        if(event){
          filterContext.value.languageId = event.value ? event.value : ''
          filterContext.value.language = event.label ? event.label : ''
        }else{
          filterContext.value.languageId = ''
          filterContext.value.language = ''
        } 
      }

     const search = (input) => {
      return customLanguages.value.filter((item) => {
        return item.label.toLowerCase().includes(input.toLowerCase())
      })
    }

    const onInputChange = (input) => {
      if (!input){
        filterContext.value.languageId = ''
        filterContext.value.language = ''
      }
    }

    const autoCompleteOptions = ref({
      search: search,
      getResultValue: (r) => {
        return r.label
      }
    })
  
</script>
  
<style scoped>

  .languages {
    display: flex;
    align-items: center;
  }
  label {
    padding-left: 10px;
  }
 
</style>

<style lang="scss">

  .languages-filter {
    ul {
      overflow-x: hidden !important;
    }
  }

</style>  